<div
  *ngFor="let file of files; last as isLast; let i = index"
  class="file-container"
  [ngClass]="{ 'not-last-row': !isLast }"
>
  <div class="metadata-container" [class]="file.errors ? 'file-error' : ''">
    <div class="document-type">
      <span class="uploaded-icon material-icons" aria-hidden="true" *ngIf="!file.errors && file.completed">
        check_box
      </span>
      <span class="error-icon material-icons" aria-hidden="true" *ngIf="file.errors && file.completed"> close </span>
      <span class="document-type-text">{{ file.documentType || categoryDisplay }}</span>
    </div>
    <div class="file-name" [attr.data-cy]="file.name + '-' + i.toString()">{{ file.name }}</div>
    <div
      *ngIf="showDateUploaded && file.dateUploaded"
      class="date-uploaded"
      [attr.data-cy]="file.dateUploaded + '-' + i.toString()"
    >
      {{ file.dateUploaded | date: 'mediumDate' }}
    </div>
    <div
      class="preview-button no-lock"
      [class]="file.errors ? 'error' : ''"
      (click)="onViewBlob(file.key)"
      iesIconButton
      data-cy="preview"
      [attr.aria-label]="ariaLabelForPreviewIcon"
      *ngIf="file.completed"
    >
      View file
    </div>
    <div class="spacer"></div>
    <div class="spacer">
      <div
        [hidden]="hideRemoveButton || isReadOnly(file.key)"
        (click)="onRemoveFile(file)"
        class="remove-button"
        data-cy="remove"
        aria-label="Remove File"
        iesIconButton
      >
        <span class="remove-icon material-icons" aria-hidden="true"> delete_outline </span>
        <span class="remove-text">Remove</span>
      </div>
    </div>
  </div>
  <ng-container *ngFor="let template of getErrorTemplates(file.errors); let i = index" [ngTemplateOutlet]="template">
  </ng-container>

  <ng-container *ngIf="hasFileErrors(file.errors, 'maxFileSize')">
    <div class="error-text">
      Unsupported file size. Please try again with file size under
      {{ fileService.formatBytes(maxFileSize) }}
      and greater than 0 bytes.
    </div>
  </ng-container>
  <ng-container *ngIf="hasFileErrors(file.errors, 'fileExtension')">
    <div class="error-text">
      Unsupported file format. Please try again with one of the following file types: {{ acceptDisplay }}.
    </div>
  </ng-container>
  <ng-container *ngIf="hasFileErrors(file.errors, 'mimeType')">
    <div class="error-text">
      Unsupported file mime type. Please try again with one of the following file types: {{ acceptDisplay }}.
    </div>
  </ng-container>
  <ng-container *ngIf="hasFileErrors(file.errors, 'protectedPdf')">
    <div class="error-text">
      PDF is password protected or encrypted. Please remove the password/encryption and try again.
    </div>
  </ng-container>
  <ng-container *ngIf="hasFileErrors(file.errors, 'invalidPdf')">
    <div class="error-text">PDF is invalid. Please select another file.</div>
  </ng-container>
  <ng-container *ngIf="hasFileErrors(file.errors, 'fillablePdf')">
    <div class="error-text">PDF is fillable. Please flatten and try again.</div>
  </ng-container>
  <ng-container *ngIf="validateDuplicate && hasFileErrors(file.errors, 'duplicateDoc')">
    <ng-container
      ><div class="error-text">{{ getFileDuplicateError(file) }}</div>
    </ng-container>
  </ng-container>

  <div class="error-text" *ngIf="file?.errors?.upload">
    <ng-container>Document Upload Failed</ng-container>
  </div>
</div>
